(function () {
  'use strict';
  function initialize(root) {
    if (!root || root.dataset.fpInitialized === 'true') return;
    root.dataset.fpInitialized = 'true';
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      if (link.hasAttribute('data-planner')) {
        var status = root.querySelector('#fp-download-confirmation');
        var message = root.querySelector('#fp-download-message');
        if (status && message) {
          message.textContent = 'Your ' + link.dataset.planner + ' PDF is opening in a new tab. If needed, use its download button or Share → Save to Files.';
          status.hidden = false;
        }
        // Does not claim successful file saving or block the browser's normal PDF action.
        root.dispatchEvent(new CustomEvent('fp:planner-download-click', {bubbles: true, detail: {planner: link.dataset.planner}}));
      }
      if (link.hasAttribute('data-offer')) {
        root.dispatchEvent(new CustomEvent('fp:planner-offer-click', {bubbles: true, detail: {position: link.dataset.offer}}));
      }
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = root.querySelector(href);
        if (target) {
          event.preventDefault();
          if (target.tagName === 'DETAILS') target.open = true;
          target.scrollIntoView({behavior: 'auto', block: 'start'});
        }
      }
    });
  }
  initialize(document.querySelector('[data-fp-offer-root]'));
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target.querySelector('[data-fp-offer-root]'));
  });
})();
